import { lazy } from 'react';

export const dashboard = lazy(() => import('./dashboard'));
